import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours'
import { TouchableOpacity } from 'react-native'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import TableInvitesPage from '../tableInvites/TableInvitesPage'
import * as SecureStore from 'expo-secure-store';
import useAxiosPrivate from '../../hooks/useAxiosPrivate'


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TableInvitesNotifications = ({ getNotificationData, setTableInvites, notificationData }) => {

    const [showTableInvitePage, setShowTableInvitePage] = useState(false)
    const [tableInviteVisible, setTableInviteVisible] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const tableInvites = notificationData?.filter(
        (n) => n.type === "tableInvite" && (n.joined === false || n.joined === "false")
    ) || [];

    const axiosPrivate = useAxiosPrivate()



    useEffect(() => {
        //console.log('tableInvitess', tableInvites)
        //console.log('notificationData', notificationData)

    }, [])

    const handleShowTableInvite = () => {
        setShowTableInvitePage(true)
    }


    const markAllTablesNotificationAsRead = async () => {
        setIsLoading(true)
        try {

            const response = await axiosPrivate.post('/markTablesNoticeSeen/markTablesNoticeSeen')

            if (response.status === 200 || response.status === 201) {

                //console.log('marked status: All Notifications Read')

            }

        } catch (error) {
            //console.log('Error Notification DatA', error)
        } finally {
            setIsLoading(false)

        }

    }


    return (
        <View>
            <ScrollView
                style={styles.componentStyle}
                contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
                showsVerticalScrollIndicator={false}
            >
                {tableInvites?.length > 0 && (
                    <View style={styles.markItem}>
                        <TouchableOpacity style={styles.joinTableButton}
                            onPress={() => { markAllTablesNotificationAsRead() }}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <ActivityIndicator size="small" color="#fff" />
                            ) : (

                                <Text style={{ color: 'white', fontSize: dynamicFontSize(12), fontFamily: 'Sen-Bold' }}>Mark all as seen</Text>
                            )}
                        </TouchableOpacity>
                    </View>
                )}


                <View style={styles.notificationItemsStyle}>

                    <FlatList
                        data={tableInvites}
                        scrollEnabled={false}
                        renderItem={({ item: invites }) => (
                            <TouchableOpacity style={styles.profileContainer}
                                onPress={handleShowTableInvite}>
                                {invites.sender.profilePicture ? (<Image source={{ uri: invites?.sender.profilePicture }} style={styles.userImage} />
                                ) : (
                                    <Image source={require('../../../assets/profile_image_holder.jpg')} style={styles.userImage} />
                                )}
                                <View >
                                    <Text style={{ color: Colours.DARKGRAY, fontSize: 15, fontFamily: 'Sen-Regular', width: 260 }}>
                                        You have been invited by<Text style={{ color: Colours.PRIMARY, fontSize: 15, fontFamily: 'Sen-Regular' }}> "{invites?.sender.username}"</Text>
                                        to join the table<Text style={{ color: Colours.PRIMARY, fontSize: 15, fontFamily: 'Sen-Regular' }}> "{invites?.relatedTable.tableCaption}" </Text>
                                    </Text>
                                </View>
                            </TouchableOpacity>)
                        } />

                </View>
            </ScrollView>

            <Modal
                animationType='fade'
                visible={showTableInvitePage}
                onRequestClose={() => setShowTableInvitePage(false)}
            >
                <TopHeaderComponent headerText={'Table Invites'} hideScreen={() => setShowTableInvitePage(false)} />
                <TableInvitesPage tableInvites={tableInvites}
                    setTableInviteVisible={setTableInviteVisible}
                    tableInviteVisible={tableInviteVisible}
                    getNotificationData={getNotificationData}
                    setTableInvites={setTableInvites}
                />
            </Modal>

        </View>
    )
}

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',
    },
    markItem: {
        display: 'flex',
        margin: dynamicSpacing(15),
        padding: dynamicSpacing(10),
        borderRadius: dynamicSize(15),

    },

    joinTableButton: {
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(5),
        padding: dynamicSpacing(5),
        backgroundColor: Colours.PRIMARY,
        height: dynamicSize(25),
        width: dynamicSize(100),
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: dynamicSpacing(15),
        marginBottom: 0,
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
        borderRadius: dynamicSize(15),

        gap: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: dynamicSize(99),

    }
})

export default TableInvitesNotifications
